import React           from 'react';
import koteret         from '../../images/koteret2.jpg';
import koteretar       from '../../images/koteret2_ar.jpg';
import { makeStyles }  from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    root: {   
        position:        'fixed',
        backgroundColor: '#FFF',
        borderRadius:    '1em',
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
       // border: '1px solid #F00'
    },
    image: {
        borderRadius:       '1em',
        overflow:           'hidden',
        height:             '100%',
        width:              '100%',
        backgroundRepeat:   'no-repeat',
        backgroundSize:     'contain',
        backgroundPosition: 'center'
    }
    
}))

type KoteretProps = {
  wideScreen: boolean;
  lang:       string;
}

const Koteret: React.FC<KoteretProps> = ({ lang, wideScreen }) => {

  const classes = useStyles();

  const rootStyle = React.useMemo(() => {
     return {
      //top:       wideScreen ? '28vh' : '30vh',
      // height:          130,
       // width:           310, 
        height:    wideScreen ? 130 : 130,
        width:     wideScreen ? 400 : 310,
        top:       wideScreen ? '26vh' : '30vh',
        left:      wideScreen ? '50vw' : '50%',
        transform: `translate(${ !wideScreen ? -50 : -10 }%, -50px)`   //@@@
      }
  },[wideScreen])

  return (
    <div 
       className = { classes.root }
       style     = { rootStyle }
    >
        <div
          className = { classes.image }
          style     = {{
            backgroundImage: `url(${ lang === 'heb' ? koteret : koteretar })`,
          }}
        />
    </div>
  );
}



export default Koteret;


